import {createGlobalStyle} from 'styled-components';
import Noyh from '../assets/fonts/Noyh.ttf';

export default createGlobalStyle`
  @font-face {
    font-family: 'Noyh';
    src: url(${Noyh});
  }

  :root {
    --max-width-content: 1400px;
    --white: #fff;
    --roxo: rgba(162, 155, 254, .1);
    height: 100%;
  }


  /* RESET */
  *, *:before, *:after {
    margin: 0;
    padding: 0;
    outline: 0;
    line-height: 1.8;
    letter-spacing: 1px;
    font-size: 1em;
    font-family: 'Noyh', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }

  h1 {

    font-size: 2em;

  }

  h2 {

    font-size: 1.8em;

  }

  h3 {

    font-size: 1.6em;

  }

  img {

    width: 100%;
    max-width: 100%;

  }

  a {

    color: #3498db;
    text-decoration: underline;

  }

  body, html, #root {
    height: 100%;
    min-height: 100%;
    color: #000;
  }

  .App{
    position: relative;
    min-height: 100%;
  }

  body {

    background-color: var(--white);

  }

  [disabled] {

    background-color: #ededed;
    color: #666;

  }

  input:disabled {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAIklEQVQIW2NkQAKrVq36zwjjgzhhYWGMYAEYB8RmROaABADeOQ8CXl/xfgAAAABJRU5ErkJggg==) repeat;
    color: #666;
  }

  /* ESTRUTURA */
  .container {
    width: 100%;
    float: left;
    padding: 20px 0;
  }

  .content {
    width: 80%;
    margin: 0 10%;
    /* max-width: var(--max-width-content); */
  }

  .clear {
    clear: both;
  }

  .font-zero {

    display: none;
    font-size: 0em;

  }

  .pointer {

    cursor: pointer;

  }

  .App {
    min-height: 100%;
  }

  .App::after {
    content: "";
    clear: both;
    display: table;
  }

  /* CORES */
  .bg-preto {

    color: #fff;
    background-color: #000;

  }

  .bg-branco {
    background-color: #fff;
    color: #000;
  }

  .shadow {
    -webkit-box-shadow: 0px 0px 5px -4px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 5px -4px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 5px -4px rgba(0, 0, 0, 0.75);
  }

  /* BOTOES */
  .btn {
    position: relative;
    display: inline-block;
    padding: 4px 12px;
    font-weight: 600;
    line-height: 20px;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-repeat: repeat-x;
    background-position: -1px -1px;
    background-size: 110% 110%;
    border: 1px solid rgba(27, 31, 35, .2);
    border-radius: .25em;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }


  .btn-vermelho {
    color: #fff;
    background-color: #ff6b6b;
    background-image: linear-gradient(-180deg, #FF014A, #FF014A 90%);
    padding: 8px 30px;
    margin-top: 5px;
    width: 100%;
    font-size: 1em;
    max-width: 300px;
    border-radius: 20px;
  }

  /* FLEX BOX */
  .ds-flex {

    display: flex;

  }

  .wrap {

    flex-wrap: wrap;

  }

  .flex {

    flex: 1;

  }

  .justify-content-center{
    justify-content: center;
  }

  .space-between {

    justify-content: space-between;

  }

  .align-items-center {

    align-items: center;

  }

  .align-items-start {

    align-items: flex-start;

  }

  .align-items-end {

    align-items: flex-end;

  }
  .centro {

    text-align: center;

  }

  .direita {

    text-align: right;

  }

  .bold{
    font-weight: bold;
  }

  .link-default {

    color: #3498db;
    transition: 1s color;
    text-decoration: none;
    cursor: pointer;

    &:hover {

      color: #2980b9;
      text-decoration: underline;

    }

  }

  .link-warning {

    color: #e74c3c;
    transition: 1s color;
    text-decoration: none;

    &:hover {

      color: #c0392b;
      text-decoration: underline;

    }

  }

  .menu-item {
    user-select: none;
    cursor: pointer;
    border: none;
  }

  .scroll-menu-arrow {
    padding: 20px;
    cursor: pointer;
  }

  .padding-tb-20 {

    padding: 20px 0;

  }
  
  ::-webkit-scrollbar {
    width: 20px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #a8bbbf;
  }
`;